import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from '@angular/material';

import { DataTableModule, CalendarModule } from 'primeng/primeng';

import { SharedModule } from 'app/shared/shared.module';

import { BankInstitutionsComponent } from './bankinstitutions.component';
import { BankInstitutionListComponent } from './bankinstitutionlist/bankinstitution-list.component';
import { BankInstitutionComponent } from './bankinstitution/bankinstitution.component';

@NgModule({
    declarations: [
        BankInstitutionsComponent,
        BankInstitutionListComponent,
        BankInstitutionComponent
    ],
    imports: [
        SharedModule,
        MaterialModule.forRoot(),
        ReactiveFormsModule,
        BrowserModule,
        FormsModule,
        FlexLayoutModule,
        DataTableModule,
        CalendarModule
    ],
    providers: [],
    entryComponents: [
        BankInstitutionComponent
    ]
})

/**
 * Main module for Bank Institutions.
*/
export class BankInstitutionsModule { }



// WEBPACK FOOTER //
// ./src/app/finance/bankinstitutions/bankinstitutions.module.ts